export default "__VITE_ASSET__d6zu0Y9f__"